<template>
  <div class="chat-message px-4 mb-3 d-flex" :class="{pinged}" @contextmenu="$emit('inspect', $event)">
    <UserAvatar :user="message.user" :size="36" class="mr-3 flex-grow-0 link" @click.native="$emit('inspect', $event)" />
    <ChatContent class="mt-1" :tokens="message.content" :user="user" :deleted="message.deleted">
      <template #prefix>
        <Username
          class="d-inline blue500--text font-weight-semibold link"
          :user="message.user"
          @click.native="$emit('inspect', $event)"
        />
        <span class="grey200--text">: </span>
      </template>
    </ChatContent>
  </div>
</template>

<script>
import ChatMessage from '@/store/models/chat/ChatMessage'
import User from '@/store/models/user/User'
import ChatContent from '@/components/Chat/ChatContent/ChatContent'

export default {
  components: { ChatContent },
  props: {
    message: {
      type: [ChatMessage, Object],
      required: true,
    },
    user: {
      type: [User, Object],
      default: null,
    },
  },
  computed: {
    pinged() {
      return this.message.isPinged(this.user)
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.chat-message {
  position: relative;
  flex-wrap: none;

  .message-body {
    min-width: 0;
  }

  &.pinged {
    padding: 8px 16px !important;
    // &::before {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 4px;
    //   height: 100%;
    //   background-color: primary(400);
    //   content: ' ';
    // }

    background-color: rgba(primary(), 0.2) !important;

    .username {
      font-weight: bold;
    }

    ::v-deep {
      .message-content {
        color: grey(100) !important;
      }
    }
  }
}
</style>
